"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Tab = require("./Tab.styles");
/**
 * The `Tabs.Tab` component is used by the `Tabs` and `Tabs.List` components.
 *
 * @extends ToggleButton
 * @since 8.10.0
 */
var Tab = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  /**
   * Use `aria-selected` instead of `aria-pressed` as per WAI-ARIA guidelines:
   * https://www.w3.org/TR/wai-aria-practices-1.2/#wai-aria-roles-states-and-properties-21
   */
  var isPressed = props.defaultPressed || props.pressed;
  return /*#__PURE__*/_react.default.createElement(_Tab.StyledTab, (0, _extends2.default)({
    "aria-pressed": undefined,
    "aria-selected": isPressed,
    ref: forwardedRef,
    role: "tab",
    size: "lg",
    tabIndex: isPressed ? '0' : '-1'
  }, props));
});
exports.Tab = Tab;
Tab.displayName = 'Tabs.Tab';
Tab.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If you're using the `Tabs` parent,
   * this must match the `id` of the
   * `Tabs.Panel` associated with this tab.
   *
   * If no `aria-controls` is specified, one will automatically be generated by the
   * `Tabs.List` parent.
   */
  'aria-controls': _propTypes.default.string,
  /**
   * Indicate if this is the selected `Tabs.Tab` and use as an
   * [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html).
   *
   * A `Tabs.Tab` can use `pressed` or `defaultPressed`, but not both.
   *
   * @ignore
   */
  'defaultPressed': _propTypes.default.bool,
  /**
   * Set the `Tabs.Tab` as disabled.
   */
  'disabled': _propTypes.default.bool,
  /**
   * Add an `Icon` to the button.
   */
  'icon': _propTypes.default.node,
  /**
   * A unique identifier. If this `Tabs.Tab`'s `id` matches its
   * `Tabs`'s or `Tabs.List`'s
   * `selected` or `defaultSelected`, this `Tabs.Tab` will be selected.
   *
   * If you're using the `Tabs` parent, this identifier
   * must also match the `aria-labelledby` of its corresponding `Tabs.Panel`.
   */
  'id': _propTypes.default.string.isRequired,
  /**
   * A click handler that receives two arguments: the click event and
   * a boolean that reflects if this is the selected `Tabs.Tab`.
   */
  'onClick': _propTypes.default.func,
  /**
   * Indicate if this is the selected `Tabs.Tab` and use as a
   * [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
   *
   * A `Tabs.Tab` can use `pressed` or `defaultPressed`, but not both.
   *
   * @ignore
   */
  'pressed': _propTypes.default.bool
} : {};